import { render } from "./AssessmentManagement.vue?vue&type=template&id=460b4a88&scoped=true"
import script from "./AssessmentManagement.vue?vue&type=script&lang=js"
export * from "./AssessmentManagement.vue?vue&type=script&lang=js"

import "./AssessmentManagement.vue?vue&type=style&index=0&id=460b4a88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460b4a88"]])

export default __exports__